class TableOfContents {
    constructor() {
        this.tocWrapper = document.querySelector('[data-toc]');
        this.tocItems = document.querySelectorAll('[data-toc-item]');
    }

    init = () => {
        this.currentItem = null;

        if (this.tocItems) {
            this.checkVisibility();
        }
    };

    checkVisibility = () => {
        [...this.tocItems].forEach((item) => {
          const target = document.getElementById(item.dataset.id);
          if(!target) return;
            const {
                top,
            } = target.getBoundingClientRect();

            if (top > -20 && top < (target.offsetHeight + 40)) {
                this.toggleActiveItem(item);
            }
        });

        setTimeout(() => {
            requestAnimationFrame(this.checkVisibility);
        }, 1000 / 60);
    }

    toggleActiveItem = (activeItem) => {
        if (!this.currentItem || this.currentItem.dataset.id !== activeItem.dataset.id) {
            if (this.currentItem) {
                this.currentItem.classList.remove('is-active');
            }
            activeItem.classList.add('is-active');
            activeItem.parentNode.scrollTop = activeItem.offsetTop; // eslint-disable-line
            this.currentItem = activeItem;
        }
    };
}

export default TableOfContents;
